import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSearchHistoryRootLangKey } from '@yme/selectors/common';
import { MAX_SEARCH_CONTENT_ITEMS, MIN_SYMBOLS_TO_SEARCH } from './constants';
export const useSearchHistory = () => {
    const [searchHistoryDefault, setSearchHistoryDefault] = useState([]);
    const [searchHistoryResult, setSearchHistoryResult] = useState([]);
    const searchHistoryKey = useSelector(getSearchHistoryRootLangKey);
    const rawData = sessionStorage.getItem(searchHistoryKey);
    const handleAddToSearchHistory = useCallback((value) => {
        if (value.length < MIN_SYMBOLS_TO_SEARCH ||
            searchHistoryDefault.some((item) => item === value)) {
            return;
        }
        if (searchHistoryDefault.length < MAX_SEARCH_CONTENT_ITEMS) {
            sessionStorage.setItem(searchHistoryKey, JSON.stringify([value, ...searchHistoryDefault]));
        }
        else {
            sessionStorage.setItem(searchHistoryKey, JSON.stringify([value, ...searchHistoryDefault.slice(0, MAX_SEARCH_CONTENT_ITEMS - 1)]));
        }
    }, [searchHistoryDefault, searchHistoryKey]);
    useEffect(() => {
        if (rawData) {
            const parsedData = JSON.parse(rawData);
            setSearchHistoryDefault(parsedData);
            const result = parsedData.map((item) => ({
                query: item,
            }));
            setSearchHistoryResult(result);
        }
    }, [rawData]);
    return {
        isSearchHistoryExisted: Boolean(searchHistoryDefault.length),
        searchHistoryResult,
        handleAddToSearchHistory,
    };
};
